import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GlobalMessages } from '../types/common.types';
import { environment } from '../../../environments/environment';
import { catchError, filter, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalMessageService {

  private httpClient = inject(HttpClient);

  constructor() { }

  getGlobalMessage() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.httpClient
      .get<GlobalMessages[]>(environment.apis.v3 + '/global-messages', { headers })
      .pipe(
        catchError((error) => {
          console.log('There was an error trying to get the global message: ', error);
          return of(null);
        }),
        filter(res => !!res)
      );
  }
}
